module.exports = {
	"header": "Meet Spotin at FIPP World Media Conference",
	"date": "2022/05/25",
	"imgSrc": "spotinxFIPP.jpg",
	"imgAlt": "Spotin x FIPP",
	"ingress": "We are excited to announce that we are one of the sponsors of FIPP World Media Congress (June 7th -9th, 2022). We will be offering our tech-solution 'Content Commerce' to all the interested media partners at the event.",
	"sections": [
		{
			"paragraphs": [
				"Spotin’s content commerce solution enables publishers or any digital site to monetise content by offering shopping experiences friction-free from the content article without any links or redirections.",
				"Our technology allows media sites to offer shopping to its users at the point of content discovery, driving high conversions with a variety of shopping features.",
				"If you are interested in adding shoppability to your content with friction-free shopping experiences to your users, then our product will be the right fit for your business.",
				"You can meet our CEO & Founder Kristoffer Karlsson and our CMO Vaishali Kaim at the conference. Book a meeting via the official deal room of FIPP World Media Congress 2022: <a style='text-decoration: underline;' href='https://letsgo.dealroomevents.com'>letsgo.dealroomevents.com</a>, or reach out to us directly at <a style='text-decoration: underline;' href='mailto:marketing@spotin.com'>marketing@spotin.com</a> and we will get back to you."
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./pages/news/4/article.json
// module id = 17
// module chunks = 0